import Swiper, { Navigation, Pagination, EffectCreative } from 'swiper';
// import 'swiper/css';

// import 'swiper/css/bundle';

export function initDefaultSwiper() {
	const _ = new Swiper(".default-swiper", {
		// Default parameters
		slidesPerView: 1.8,
		centeredSlides: true,
		spaceBetween: 0,
		loop: true,
		grabCursor: true,

		// pagination: {
		// 	el: ".default-swiper-pagination",
		// },
	});
}

export function initReviewsSwiper() {
	const _ = new Swiper(".reviews-swiper", {
		// Default parameters
		slidesPerView: 1.3,
		spaceBetween: 60,
		centeredSlides: false,
		loop: true,
		grabCursor: true,
			breakpoints: {
			640: {
				
				slidesPerView: 2,
				spaceBetween: 60,
				centeredSlides: true,
			},
			768: {
				slidesPerView: 3.2,
				spaceBetween: 120,
				centeredSlides: true,

			},
			977: {
				slidesPerView: 4,
				spaceBetween: 120,
				centeredSlides: true,

			},
		},
	});
}

export function initQuotesSwiper() {
	const _ = new Swiper(".quotes-swiper", {
		modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 32,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
		pagination: {
			el: ".quotes-pagination",
			clickable: true
		},
	});
}


// export function initCreativeSwiper() {
//   const _ = new Swiper(".creative-swiper", {
// 		// Default parameters
//     modules: [Navigation, Pagination, EffectCreative],
//     // slidesPerView: 1,
//     spaceBetween: 30,
// 		loop: true,
// 		grabCursor: true,

//     // centeredSlides: true,
//     effect: "creative",
//     creativeEffect: {
//       prev: {
//         shadow: true,
//         translate: ["-125%", 0, -800],
//         // rotate: [0, 0, -90],
//       },
//       next: {
//         shadow: true,
//         translate: ["125%", 0, -800],
//         // rotate: [0, 0, 90],
//       },
//     },

// 		pagination: {
// 			el: ".creative-swiper-pagination",
// 			clickable: true
// 		},

// 		navigation: {
// 			nextEl: ".creative-swiper-next",
// 			prevEl: ".creative-swiper-prev",
// 		},
// 	});	
// }

export function newCreativeSwipers() {
	const multipleCreativeSliders = ()=>{
		let multipleCreativeSlider = document.querySelectorAll('.creative-swiper')
	let prevArrow = document.querySelectorAll('.creative-swiper-prev')
	let nextArrow = document.querySelectorAll('.creative-swiper-next')
	let pagination = document.querySelectorAll('.creative-swiper-pagination')

		multipleCreativeSlider.forEach((slider, index)=>{
			let sliderLength = slider.children[0].children.length
			let result = (sliderLength > 1) ? true : false

			const swiper = new Swiper(slider, {
				// Default parameters
				modules: [Navigation, Pagination, EffectCreative],
				// slidesPerView: 1,
				spaceBetween: 30,
				loop: result,
				grabCursor: true,
				// centeredSlides: true,
				// autoplay: {
				// 	delay: 5000
				// },
				effect: "creative",
				creativeEffect: {
					prev: {
						shadow: false,
						// opacity: 0.5,
						translate: ["-75%", 0, -800],
						// rotate: [0, 0, -90],
					},
					next: {
						shadow: false,
						// opacity: 0.5,
						translate: ["75%", 0, -800],
						// rotate: [0, 0, 90],
					},
				},

				pagination: {
					el: pagination[index],
					clickable: true
				},

				navigation: {
					nextEl: nextArrow[index],
					prevEl: prevArrow[index],
				},

			});
		});
	};
	window.addEventListener('load', multipleCreativeSliders)
}
